
import { Shield } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AddRuleSheet } from "./AddRuleSheet";

export const EmptyNetworkRuleState = () => {
  return (
    <Card className="border-dashed border-2 border-gray-300">
      <CardContent className="flex flex-col items-center justify-center py-12">
        <Shield className="w-12 h-12 text-gray-400 mb-4" />
        <h3 className="text-lg font-semibold text-gray-900 mb-2">No Network Rules</h3>
        <p className="text-gray-500 text-center mb-6 max-w-md">
          Get started by creating your first network rule to control WebKit and Socket traffic across your organization.
        </p>
        <AddRuleSheet>
          <Button className="flex items-center space-x-2">
            <span>Create First Rule</span>
          </Button>
        </AddRuleSheet>
      </CardContent>
    </Card>
  );
};
